import SliderPerView from "./slider-per-view.component";

export default SliderPerView;
